export default __webpack_public_path__ + "static/Futura-BoldCondensed-794f95e1cf4d2daf0d55d0073dca9d76.woff";